<template>
  <div class="content no-flex active">
    <slot></slot>
    <div ref="addLineItemDialogContainer"></div>
    <ed-section
      class="no-flex active pad"
      wide
      v-for="(event, index) in model.PO.events"
      v-if="event.lineItems"
      :key="index"
    >
      <slot name="top"></slot>
      <div class="section-title">
        <span class="h5">{{getGridTitle(event)}}</span>
        <div class="pull-right small"></div>
      </div>
      <div class="col-md-12">
        <grid
          layout="frame"
          :class="{ simple: false }"
          :subtitle="`${model.PO.uniqueId} ${event.name} Items`"
          label="Item"

          search="search"
          :allow-export="false"
          :export-btn="true"
          :checkboxes="true"

          :actions="itemsActions"
          :views="false"
          :pinning="false"
          :sorting="false"
          :dragRows="true"
          :fit-columns="true"
          :show-column-selector="true"
          auto-height="auto-height"

          :rowClasses="{'line-item-row': params => !(params.data || {}).isFeeDiscountItem && (params.data || {}).poQuantity,
            'readonly-row': params => (params.data || {}).isQuantityReadonly,
            'hide-units': params => !(params.data || {}).isFeeDiscountItem && +(params.data || {}).poUnits <= 0}"

          :model="gridModel"
          :data="event.lineItems"
          :key="gridKey + itemsHash(event.lineItems)"
          :rowDetailsComponent="itemDetailsComponent"

          :remove-many="true"
          :clone-many="true"
          :customDeleteManyButton="true"

          :validate-remove-many="validateRemoveMany"
          :validate-clone-many="validateCloneMany"

          @editRow="openEditItem($event, event)"
          @changeRow="refresh"
          @removeRow="removeRow"
          @removeRows="removeRows"
          @cloneRow="cloneRow"
          @cloneRows="cloneRows"
          @dropRow="reorderItemsInList($event, event)"
          @selectedRows='rowSelected'

          :currency-code="currency"
          totals="totals"
          :total="getGridTotal(event)"
          :enableErrorMessage="invoiceSettings.IsSameDayDeposit"
          helptip-header=""
          :helptip-body="sameDayValidationError"

          ref="lineItems"
          name='line items'
        >
          <span slot="additionalButtons">
            <ed-button class="btn btn-actionbar"
              v-if="useSavingsFields && !isP2PInvoiceWithEditItem"
              :toggle="savingsFields"
            >Cost Savings
            </ed-button>

            <ed-button class="btn btn-actionbar"
              v-if='!isP2PInvoice'
              @click="checkIfCurrencyIsSelected(event, 'AddItem')"
              name='add_item'
            >Add Line Item
            </ed-button>

            <slot name="buttons" :event="event"></slot>
          </span>
          <span slot="selectionButtons">
            <span v-if='useBUorCCorPair && !isP2PInvoice'>
              <ed-button class="btn btn-actionbar"
                @click="openAllocateToCostCenterDialog(event)"
                v-if='allocateToCostCenter'
                name='allocate_to_CC'
              >Allocate to Cost Center
              </ed-button>

              <ed-button class="btn btn-actionbar"
                @click="openAllocateToBUCCPairDialog(event)"
                v-if='allocateToBUCCPair'
                name='allocate_to_CCBU_Pair'
              >Allocate to BU and CC
              </ed-button>
            </span>
          </span>
        </grid>

        <br v-if="event.lineItems.length" />
      </div>
      <div class="clear"/>
    </ed-section>
    <ed-modal
      :show='showCurrencyError'
      @close='showCurrencyError = false'
      title=''
      primaryButton='false'
      secondaryButton='Ok'
      type='small'
      name='currency_error'
    >
      <div slot="body">
        <p><br>Please select the Invoice Currency in order to add items to this invoice.</p>
      </div>
    </ed-modal>
  </div>
</template>

<script>
/* eslint spec-file: 0 */

import Grid from '@/components/Grid'
import { edit, remove, expand, clone } from '@/components/Grid/cells/actions'

import LineItem from './models/line-item'
import itemDetailsComponent from './components/itemDetails'
import EventsSection from './EventsSection/EventsSection.js'

import AddLineItem from './dialogs/LineItem/AddLineItem.vue'
import AddFeesDiscountItem from './dialogs/LineItem/AddFeesDiscountItem.vue'
import AllocateToCC from './dialogs/LineItem/AllocateToCC.vue'
import AllocateToBUCCPair from './dialogs/LineItem/AllocateToBUCCPair.vue'

import LineItemStore from './dialogs/LineItem/LineItemStore.js'

import { EventBus } from '@/event-bus'
import Events from '@/core/events/events'
import Vue from 'vue'
var eventHub = new Vue()

export default {
  components: {
    Grid
  },

  props: {
    model: Object,
    dependencies: Object,
    events: Object,
    programId: Number,
    invoiceId: Number,
    settings: Object,
    isP2PInvoice: Boolean,
    buyerVendorId: Number,
    useSavingsFields: Boolean,
    invoiceSettings: Object,
    decouplingSettings: Object,
    qtyAndUnitsOnPO: [Object, Array]
  },

  computed: {
    customItemsLabel() {
      return 'Add Fees/Discount'
    },

    isP2PInvoiceWithEditItem() {
      return this.isP2PInvoice && this.settings.AllowEditItem
    },

    currency() {
      return this.model.PO.currency.code
    },

    currencyObj() {
      return this.model.PO.currency
    },

    itemsActions() {
      return [expand, edit, clone, remove]
    },

    useBUorCCorPair() {
      return this.settings && (this.settings.HasBusinessUnit || this.settings.HasCostCenter || this.settings.UseBusinessUnitAndCostCenterMapping)
    },

    gridModel() {
      return LineItem.get(this.programCategories, this.useSavingsFields,
        this.isP2PInvoice, this.settings, this.model.PO.currency.code)
    },

    gridKey() {
      return this.programId + ' ' + +this.useSavingsFields + ' ' + this.model.PO.currency.code
    }
  },

  data() {
    return {
      LineItem,
      itemDetailsComponent,
      programCategories: [],
      itemModal: {
        display: false,
        categories: [],
        businssUnitAndCostCenters: [],
        units: []
      },
      doDisplayNoEventError: false,
      eventsSectionData: new EventsSection(this.dependencies),
      showCurrencyError: false,
      allocateToCostCenter: false,
      allocateToBUCCPair: false,
      selectedRows: [],
      savingsFields: ['unitPriceSGR', 'unitPricePreferredRate', 'unitPriceNegotiatedRate'],
      sameDayValidationError: 'Negative amounts are not allowed for ' + utils.constants.invoice.SameDayLabel.toLowerCase() + ' deposit invoices.',
      orderedItems: {},

      itemsHash: items => items.map(item => item.itemKey + item.totalWithTaxesAndFees || '').join('')
    }
  },

  methods: {
    store() {
      return new LineItemStore(this.api)
    },

    hasMoreThanOneEvent() {
      return this.model.PO.events && this.model.PO.events.length > 1
    },

    getGridTotal(_event) {
      return this.isP2PInvoice && _event && this.hasMoreThanOneEvent()
        ? _event.total
        : this.model.PO.total
    },

    getGridTitle(_event) {
      return 'Line Items' +
        (this.isP2PInvoice && _event && this.hasMoreThanOneEvent() ? ' for ' + _event.name : '')
    },

    async reorderItemsInList(listOrderChangeDetails, event) {
      let sourceLineItem = event.lineItems.filter(
        x => +x.listOrder - 1 === listOrderChangeDetails.from
      )[0]

      let targetLineItem = event.lineItems.filter(
        x => +x.listOrder - 1 === listOrderChangeDetails.to
      )[0]

      if (sourceLineItem && targetLineItem) {
        sourceLineItem.listOrder = +targetLineItem.listOrder
      }

      // move item up in the grid
      if (listOrderChangeDetails.from > listOrderChangeDetails.to) {
        for (var i = listOrderChangeDetails.from; i > listOrderChangeDetails.to; i--) {
          event.lineItems[i] = event.lineItems[i - 1]
          event.lineItems[i].listOrder = +event.lineItems[i].listOrder + 1
        }
        event.lineItems[listOrderChangeDetails.to] = sourceLineItem
      }
      // move item down in the grid
      if (listOrderChangeDetails.from < listOrderChangeDetails.to) {
        for (var j = listOrderChangeDetails.from; j < listOrderChangeDetails.to; j++) {
          event.lineItems[j] = event.lineItems[j + 1]
          event.lineItems[j].listOrder = +event.lineItems[j].listOrder - 1
        }
        event.lineItems[listOrderChangeDetails.to] = sourceLineItem
      }

      await this.recalculatePo()
    },

    checkIfCurrencyIsSelected(event, modalToOpen) {
      let canAddEditItem = this.model.PO.currencySelected ||
        this.isP2PInvoiceWithEditItem

      if (canAddEditItem) {
        if (modalToOpen === 'AddItem') {
          this.openLineItemDialog(event)
        }
        if (modalToOpen === 'AddFeesDiscount') {
          this.openFeeOrDiscountItemDialog(event)
        }
      } else {
        this.showCurrencyError = true
      }
    },

    async recalculatePo() {
      let previousPOTotalAmount = +this.model.PO.total

      this.model.PO = await this.eventsSectionData.recalculatePoAndReturnIt(
        this.model.PO, this.settings, this.isP2PInvoiceWithEditItem
      )
      this.model.PO.events = this.store().getEventsWithOrderedLineItems(this.model.PO.events)

      EventBus.$emit(Events.I2P.UPDATE_SNAPSHOT, {
        total: +this.model.PO.total,
        totalVATGST: this.getTotalVATGST(),
        programCurrencyCode: this.model.PO.programDetails.currencyCode
      })

      if (this.settings.EditingInvoiceScan) {
        EventBus.$emit(Events.I2P.UPDATE_INVOICE_SCAN_SNAPSHOT, {
          total: +this.model.PO.total,
          invoiceCurrencyCode: this.currencyObj.code
        })
      }

      if (this.isP2PInvoiceWithEditItem) {
        EventBus.$emit(Events.I2P.PO_AMOUNT_CHANGED, {
          total: +this.model.PO.total,
          previousTotal: previousPOTotalAmount
        })
      }

      this.updateLineItemGrids()
    },

    getTotalVATGST() {
      let totalVATGST = 0
      this.model.PO.events.map(ev => {
        totalVATGST += +this.model.PO.events[0].vat + +this.model.PO.events[0].gst
      })
      return totalVATGST
    },

    openEditItem(item, event) {
      if (item.data.isFeeDiscountItem) {
        this.openFeeOrDiscountItemDialog(event, item.data)
      } else {
        this.selectedLineItem = item.data
        this.itemModal.editMode = true
        this.openLineItemDialog(event, item.data)
      }
    },

    async refresh(item, success, fail, done) {
      this.updateFeesPerItem(item)

      this.validateItem(item)

      if (this.useSavingsFields) {
        await this.store()
          .computeSavingsItemTotal(item.data, this.currencyObj)
          .then(response => {
            this.afterComputeTotals(item.data, response)
          })
      } else {
        await this.store()
          .computeItemTotal(item.data, this.currencyObj)
          .then(response => {
            this.afterComputeTotals(item.data, response)
          })
      }

      await this.recalculatePo()
      done()
    },

    afterComputeTotals(itemData, response) {
      let newItem = this.store()
        .populateTotalsOnItem(
          itemData,
          response.data.lineItem,
          this.decouplingSettings
        )

      // TBD: currently only for i2p invoices the line items can be changed inline in the table
      this.model.PO.events[0].lineItems.map(item => {
        if (Number(item.listOrder) === Number(newItem.listOrder)) {
          item = newItem
        }
        return item
      })
    },

    validateItem(item) {
      if (item.data.entireRowInvalid) {
        item.data._invalid = 'true'
      }
      if (!item.data.name || item.data.name.trim() === '') {
        item.data._invalid = 'true'
      } else {
        item.data._invalid = ''
      }
      if (Number(item.data.unitPrice) === 0) {
        item.data._invalid = 'true'
      } else {
        item.data._invalid = ''
      }
    },

    updateFeesPerItem(item) {
      if (item.columnId === 'quantity') {
        if (item.data.quantity !== item.oldValue) {
          item.data.fees.map(fee => {
            if (parseInt(fee.valuePerItem) !== 0) {
              fee.value = item.data.quantity * fee.valuePerItem
            }
          })
        }
      }
    },

    validateRemoveMany(payload) {
      // Item Type ID - Fee: 2, Discount: 3
      let hasFee = this.hasAutoGeneratedItemsByType(payload, 2)
      let hasDiscount = this.hasAutoGeneratedItemsByType(payload, 3)

      if (hasFee && !hasDiscount) {
        return 'The Payment Processing Fee cannot be deleted.'
      } else if (hasDiscount && !hasFee) {
        return 'The Early Payment Discount cannot be deleted.'
      } else if (hasFee && hasDiscount) {
        return 'These items cannot be deleted.'
      } else if (this.isP2PInvoiceWithEditItem && !this.hasOnlyTaxes(payload)) {
        return 'Only fees/taxes can be deleted.'
      }
      return ''
    },

    validateCloneMany(payload) {
      // Item Type ID - Fee: 2, Discount: 3
      let hasFee = this.hasAutoGeneratedItemsByType(payload, 2)
      let hasDiscount = this.hasAutoGeneratedItemsByType(payload, 3)

      if (hasFee && !hasDiscount) {
        return 'The Payment Processing Fee cannot be duplicated.'
      } else if (hasDiscount && !hasFee) {
        return 'The Early Payment Discount cannot be duplicated.'
      } else if (hasFee && hasDiscount) {
        return 'These items cannot be duplicated.'
      } else if (this.isP2PInvoiceWithEditItem && !this.hasOnlyTaxes(payload)) {
        return 'Only fees/taxes can be duplicated.'
      }
      return ''
    },

    hasOnlyTaxes(items) {
      // check if only taxes/fees were selected
      let valid = true
      items.map(item => {
        if (parseInt(item.data.itemTypeId) !== 1) {
          valid = false
        }
      })
      return valid
    },

    hasAutoGeneratedItemsByType(payload, itemTypeId) {
      let hasItems = false
      payload.map(item => {
        if (item.data.isAutoGenerated && parseInt(item.data.itemTypeId) === itemTypeId) {
          hasItems = true
        }
      })
      return hasItems
    },

    getEventForDeletedItem(itemDeleted) {
      if (!itemDeleted) return null

      let resultEvent = null
      this.model.PO.events.map(ev => {
        if (ev.lineItems.indexOf(itemDeleted) > -1) {
          resultEvent = ev
        }
      })

      return resultEvent
    },

    async removeRow(payload, success, fail) {
      if (this.canDeletedOrDuplicateItem(+payload.index)) {
        let poEvent = this.getEventForDeletedItem(payload.data)
        if (poEvent == null) return

        // reorder listOrder property
        this.decreaseListOrderAfterRemove(poEvent, +payload.index)

        // remove
        poEvent.lineItems.splice(+payload.index, 1)

        success()

        await this.recalculatePo()
      } else {
        this.showWrongActionOnItemError('deleted')
      }
    },

    async removeRows(payload, success) {
      let itemsToDelete = payload.rows.map(k => k.data)
      let poEvent = null

      // reorder listOrder property
      let indexOfItemsToRemove = []

      if (itemsToDelete.length > 0) {
        poEvent = this.getEventForDeletedItem(itemsToDelete[0])
        poEvent && poEvent.lineItems.map((item, index) => {
          if (itemsToDelete.indexOf(item) > -1 &&
            !item.isAutoGenerated && /* taxes/fees generated from backend are not editable */
            this.canDeletedOrDuplicateItem(index)) {
            indexOfItemsToRemove.push(+item.listOrder)
          }
        })
      }

      if (indexOfItemsToRemove.length > 0) {
        // invers order
        indexOfItemsToRemove.sort(function(a, b) { return b - a })
        indexOfItemsToRemove.map(idx => {
          this.decreaseListOrderAfterRemove(poEvent, idx)
        })
      } else {
        return
      }

      // remove the items
      this.model.PO.events.map(ev => {
        ev.lineItems = ev.lineItems.filter(item => itemsToDelete.indexOf(item) <= -1)
      })
      success()

      await this.recalculatePo()
    },

    async rowSelected(event) {
      this.selectedRows = event

      if (event && event.length > 0 && event[0].data && event[0].data.costCenterAndBusinessUnit) {
        let buCC = event[0].data.costCenterAndBusinessUnit

        let missingPairAndCC =
          !buCC.costCenterAndBusinessUnitKey && !buCC.costCenterAndBusinessUnitName &&
          !buCC.costCenterNo && !buCC.costCenterName
        let isProcessingFeeItem = this.settings.UseOneCostCenterOrPair &&
          !this.model.PO.allocateProcessingFeeToEveryCostCenter &&
          event[0].data && event[0].data.isAutoGenerated && event[0].data.feeTypeId > 0

        if (missingPairAndCC) {
          if (this.settings) {
            this.allocateToBUCCPair = this.settings.UseBusinessUnitAndCostCenterMapping &&
              (!this.settings.UseOneCostCenterOrPair || isProcessingFeeItem)
            this.allocateToCostCenter = !this.settings.UseBusinessUnitAndCostCenterMapping &&
              this.settings.HasCostCenter &&
              (!this.settings.UseOneCostCenterOrPair || isProcessingFeeItem)
          }
        } else {
          let programHasPairs = buCC.costCenterAndBusinessUnitKey || buCC.costCenterAndBusinessUnitName
          let programHasCC = buCC.costCenterNo || buCC.costCenterName

          this.allocateToBUCCPair = programHasPairs && this.settings && this.settings.UseBusinessUnitAndCostCenterMapping &&
            (!this.settings.UseOneCostCenterOrPair || isProcessingFeeItem)
          this.allocateToCostCenter = programHasCC && !this.allocateToBUCCPair && this.settings && this.settings.HasCostCenter &&
            (!this.settings.UseOneCostCenterOrPair || isProcessingFeeItem)
        }
      }
    },

    async cloneRow(rowIdx, success, b) {
      this.clone(rowIdx)
      success()
      await this.recalculatePo()
    },

    clone(rowIndex) {
      if (this.canDeletedOrDuplicateItem(rowIndex - 1)) {
        let maxListOrder = this.calculateMaxListOrder()

        let rowJsontoClone = utils.copy(this.model.PO.events[0].lineItems[rowIndex - 1])
        rowJsontoClone.itemKey = undefined

        rowJsontoClone.listOrder = Number(maxListOrder) + 1
        rowJsontoClone._expanded = false

        this.model.PO.events[0].lineItems.push(rowJsontoClone)
      } else {
        this.showWrongActionOnItemError('duplicated')
      }
    },

    calculateMaxListOrder() {
      let maxListOrder = -1
      this.model.PO.events[0].lineItems.map(item => {
        if (Number(item.listOrder) > maxListOrder) {
          maxListOrder = Number(item.listOrder)
        }
        return item
      })
      return maxListOrder
    },

    canDeletedOrDuplicateItem(itemIndex) {
      let item = this.model.PO.events[0].lineItems[itemIndex]
      if (item && item.itemTypeId === null && this.isP2PInvoiceWithEditItem) {
        return false
      }
      return true
    },

    showWrongActionOnItemError(action) {
      let msg = action === 'allocation'
        ? 'Allocation cannot be changed for Payment Processing Fee'
        : 'Only taxes can be ' + action
      global.app.$notifications.notify({
        alert: true,
        type: 'plain',
        icon: 'exclamation-circle',
        placement: { from: 'top', align: 'center' },
        timeout: 0,
        message: msg
      })
    },

    async cloneRows(payload, success, b) {
      payload && payload.rows && payload.rows.length > 0 && payload.rows.map(item => {
        // taxes/fees generated from backend are not editable
        if (!item.data.isAutoGenerated) {
          let rowIdx = Number(item.id)
          this.clone(rowIdx + 1)
        }
        return item
      })

      success()
      await this.recalculatePo()
    },

    decreaseListOrderAfterRemove(poEvent, removedItemIndex) {
      poEvent && poEvent.lineItems.map((lineItem, index) => {
        if (+lineItem.listOrder > +removedItemIndex) {
          lineItem.listOrder = +lineItem.listOrder - 1
        }
        return lineItem
      })
    },

    openFeeOrDiscountItemDialog(event, draftItem) {
      let ComponentClass = Vue.extend(AddFeesDiscountItem)
      let itemModal = {
        programId: +this.programId,
        invoiceId: +this.invoiceId,
        currency: this.currencyObj
      }

      if (draftItem) {
        this.itemModal.editMode = true
        itemModal.draftItem = JSON.parse(JSON.stringify(draftItem))
        itemModal.draftItem.amountType = {
          amountType: null,
          text: null
        }
      } else {
        this.itemModal.editMode = false
      }

      let instance = new ComponentClass({
        propsData: {
          type: 'primary',
          model: itemModal,
          dependencies: this.dependencies,
          eventHub: eventHub,
          eventId: event.uniqueId,
          programId: this.programId
        }
      })
      instance.$slots.default = []
      instance.$mount()
      this.$refs.addLineItemDialogContainer.appendChild(instance.$el)
    },

    openLineItemDialog(event, draftItem) {
      if (draftItem) {
        this.itemModal.editMode = true
      } else {
        this.itemModal.editMode = false
      }
      let itemModal = {
        programUniqueId: this.model.PO.programDetails.uniqueId,
        taxes: this.model.taxes ? JSON.parse(JSON.stringify(this.model.taxes)) : '',
        fees: this.model.fees ? JSON.parse(JSON.stringify(this.model.fees)) : '',
        totalWithTaxesAndFees: 0,
        categories: '',
        currency: this.currencyObj,
        useSupplementalPrecision: this.settings.CurrenciesWithSupplementalPrecision.indexOf(this.currencyObj.code) !== -1,
        unitPrice: '',
        quantity: '',
        units: this.model.units ? JSON.parse(JSON.stringify(this.model.fees)) : '',
        poUniqueId: this.itemModal.editMode ? this.model.PO.uniqueId : 'PO',
        programId: this.programId,
        invoiceId: this.invoiceId,
        supplierVci: this.model.PO.supplier.vci,
        supplierCountry: this.model.PO.supplier.address.country,
        vatGstPercentagesPerCountry: this.settings.VatGstPercentagesPerCountry,
        events: this.model.PO.events,
        buyerVendorId: this.buyerVendorId,
        useSavingsFields: this.useSavingsFields && !this.isP2PInvoiceWithEditItem,
        IsRequiredCategRefID: this.settings.IsRequiredCategRefID,
        canEditOnlyPrice: this.isP2PInvoiceWithEditItem,
        checkQuantitiesAgainstPO: this.isP2PInvoiceWithEditItem && !this.settings.AllowInvoiceToExceedPOQty
      }

      if (draftItem) {
        itemModal.draftItem = JSON.parse(JSON.stringify(draftItem))

        if (this.isP2PInvoiceWithEditItem && this.decouplingSettings) {
          let poPricingPerItem = this.decouplingSettings.filter(function(itm) {
            return itm.itemId === itemModal.draftItem.itemKey
          })

          if (poPricingPerItem) {
            poPricingPerItem = poPricingPerItem[0]
            itemModal.maxThreshold = {
              quantity: poPricingPerItem.poQuantity,
              units: poPricingPerItem.poUnits,
              unitPrice: draftItem.maxUnitPrice,
              totalAmount: draftItem.maxTotalAmount,
              excludeTaxes: poPricingPerItem.excludeTaxes
            }
          }
        }
      }

      var ComponentClass = Vue.extend(AddLineItem)
      var instance = new ComponentClass({
        propsData: {
          type: 'primary',
          model: itemModal,
          dependencies: this.dependencies,
          eventHub: eventHub,
          eventId: event.uniqueId
        }
      })
      instance.$slots.default = []
      instance.$mount()
      this.$refs.addLineItemDialogContainer.appendChild(instance.$el)
    },

    canAllocateBuAndCc() {
      let canAllocate = true
      if (this.model.PO.allocateProcessingFeeToEveryCostCenter) {
        this.selectedRows.map(function(itm) {
          if (itm.data.isAutoGenerated && +itm.data.itemTypeId === 2 /* fee */) {
            canAllocate = false
          }
        })
      }
      return canAllocate
    },

    openAllocateToCostCenterDialog(event) {
      // validate
      let canAllocate = this.canAllocateBuAndCc()

      if (canAllocate) {
        let itemModal = {
          programId: this.programId,
          selectedRows: this.selectedRows
        }
        var ComponentClass = Vue.extend(AllocateToCC)
        var instance = new ComponentClass({
          propsData: {
            type: 'primary',
            model: itemModal,
            dependencies: this.dependencies,
            eventHub: eventHub,
            eventUniqueId: event.uniqueId
          }
        })
        instance.$slots.default = []
        instance.$mount()
        this.$refs.addLineItemDialogContainer.appendChild(instance.$el)
      } else {
        this.showWrongActionOnItemError('allocation')
      }
    },

    openAllocateToBUCCPairDialog(event) {
      // validate
      let canAllocate = this.canAllocateBuAndCc()

      if (canAllocate) {
        let itemModal = {
          programId: this.programId,
          selectedRows: this.selectedRows
        }
        var ComponentClass = Vue.extend(AllocateToBUCCPair)
        var instance = new ComponentClass({
          propsData: {
            type: 'primary',
            model: itemModal,
            dependencies: this.dependencies,
            eventHub: eventHub,
            eventUniqueId: event.uniqueId
          }
        })
        instance.$slots.default = []
        instance.$mount()
        this.$refs.addLineItemDialogContainer.appendChild(instance.$el)
      } else {
        this.showWrongActionOnItemError('allocation')
      }
    },

    getEventByUniqueId(uniqueId) {
      return this.model.PO.events.filter(
        ev => ev.uniqueId === uniqueId
      )[0]
    },

    async onSaveLineItem(item) {
      item = item && item.data
      if (this.itemModal.editMode === false) {
        let poEvent = this.getEventByUniqueId(item.eventUniqueId)

        let selectedLineItem = {}
        selectedLineItem.listOrder = poEvent.lineItems.length + 1
        selectedLineItem.isFeeDiscountItem = false

        selectedLineItem = this.eventsSectionData.mapLineItemPropertiesFromSourceToTargetForCreate(
          selectedLineItem,
          item.data
        )
        poEvent.lineItems.push(selectedLineItem)
      } else {
        let selectedLineItem = this.selectedLineItem
        this.eventsSectionData.mapLineItemPropertiesFromSourceToTargetForEdit(
          selectedLineItem,
          item.data
        )
        this.selectedLineItem._pending = true
        this.selectedLineItem._loading = true
        this.updateLineItemGrids()
      }

      await this.recalculatePo()
    },

    async onSaveAllocateToCC(p) {
      p = p && p.data

      var costCenterSelected = p.data.costCenter
      var itemsIndexToUpdate = p.data.itemsToUpdate
      let poEvent = this.getEventByUniqueId(p.data.eventUniqueId)

      poEvent && itemsIndexToUpdate && itemsIndexToUpdate.map(idx => {
        let lineItem = poEvent.lineItems[idx]

        if (lineItem) {
          lineItem.costCenterAndBusinessUnit.costCenterNo = costCenterSelected.code
          lineItem.costCenterAndBusinessUnit.costCenterName = costCenterSelected.name
          lineItem.costCenterAndBusinessUnit.costCenterId = +costCenterSelected.costCenterId
        }
        return 0
      })

      await this.recalculatePo()
    },

    async onSaveAllocateToBUCCPair(p) {
      p = p && p.data

      var buCCPairSelected = p.data.buCCPair
      var itemsIndexToUpdate = p.data.itemsToUpdate
      let poEvent = this.getEventByUniqueId(p.data.eventUniqueId)

      poEvent && itemsIndexToUpdate && itemsIndexToUpdate.map(index => {
        let lineItem = poEvent.lineItems[index]

        if (lineItem) {
          if (lineItem.pairedBusinessUnitAndCostCenter) {
            lineItem.pairedBusinessUnitAndCostCenter.key = buCCPairSelected.key
            lineItem.pairedBusinessUnitAndCostCenter.name = buCCPairSelected.name
            lineItem.pairedBusinessUnitAndCostCenter.businessUnitId = +buCCPairSelected.businessUnitId
            lineItem.pairedBusinessUnitAndCostCenter.costCenterId = +buCCPairSelected.costCenterId
            lineItem.pairedBusinessUnitAndCostCenter.programBusinessUnitAndCostCenterId = +buCCPairSelected.programBusinessUnitAndCostCenterId
          }
          if (lineItem.costCenterAndBusinessUnit) {
            lineItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitKey = buCCPairSelected.key
            lineItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitName = buCCPairSelected.name
            lineItem.costCenterAndBusinessUnit.businessUnitId = +buCCPairSelected.businessUnitId
            lineItem.costCenterAndBusinessUnit.costCenterId = +buCCPairSelected.costCenterId
            lineItem.costCenterAndBusinessUnit.programBusinessUnitAndCostCenterId = +buCCPairSelected.programBusinessUnitAndCostCenterId
          }
          lineItem.useBusinessUnitAndCostCenterMapping = true
        }
        return 0
      })

      await this.recalculatePo()
    },

    async onSaveFeeOrDiscountItem(item) {
      item = item && item.data

      let event = this.model.PO.events.filter(
        x => x.uniqueId === item.eventId
      )[0]

      let selectedItem = {}

      if (!this.itemModal.editMode) {
        selectedItem.listOrder = event.lineItems.length + 1
        event.lineItems.push(selectedItem)
      } else {
        selectedItem = event.lineItems.filter(
          x => +x.listOrder === +item.data.listOrder
        )[0]
      }

      selectedItem = this.eventsSectionData.getLineItemListElementFromFeeDiscount(
        selectedItem,
        item.data
      )
      selectedItem._disabled = true

      this.recalculatePo()
    },

    onCloseAddLineItem() {
      //
    },

    onCloseAddFeeOrDiscountItem() {
      //
    },

    updateLineItemGrids() {
      if (this.$refs.lineItems) {
        for (var i = 0; i < this.$refs.lineItems.length; i++) {
          this.$refs.lineItems[i].updateRowData()
          this.$refs.lineItems[i].onSelectAll(false)
        }
      }
    }
  },

  async created() {
    this.store().getLineItemLists(
      this.programId,
      this.invoiceId
    ).then(response => {
      response && response.data && response.data.categories.map(item => this.programCategories.push(item))
    })

    if (this.model.PO &&
      ((this.model.PO.events[0] &&
      this.model.PO.events[0].lineItems &&
      this.model.PO.events[0].lineItems.length > 0) ||
      (this.invoiceSettings.IsScanning && this.settings.EditingInvoiceScan))) {
      this.model.PO.currencySelected = true
      this.showCurrencyError = false
    }

    /* NOT USED
    EventBus.$off('onCloseAddLineItem')
    EventBus.$on('onCloseAddLineItem', this.onCloseAddLineItem)

    EventBus.$off('onCloseAddFeeOrDiscountItem')
    EventBus.$on('onCloseAddFeeOrDiscountItem', this.onCloseAddFeeOrDiscountItem) */

    EventBus.$off('onSaveLineItem')
    EventBus.$on('onSaveLineItem', this.onSaveLineItem)

    EventBus.$off('onSaveAllocateToCC')
    EventBus.$on('onSaveAllocateToCC', this.onSaveAllocateToCC)

    EventBus.$off('onSaveAllocateToBUCCPair')
    EventBus.$on('onSaveAllocateToBUCCPair', this.onSaveAllocateToBUCCPair)

    EventBus.$off('onSaveFeeOrDiscountItem')
    EventBus.$on('onSaveFeeOrDiscountItem', this.onSaveFeeOrDiscountItem)

    EventBus.$off(Events.I2P.RECALCULATE_PO)
    EventBus.$on(Events.I2P.RECALCULATE_PO, this.recalculatePo)

    await this.recalculatePo()
  },

  beforeDestroy() {
    EventBus.$off('onCloseAddLineItem')
    EventBus.$off('onSaveLineItem')

    EventBus.$off('onCloseAddFeeOrDiscountItem')
    EventBus.$off('onSaveFeeOrDiscountItem')
    EventBus.$off('onSaveAllocateToBUCCPair')

    EventBus.$off(Events.I2P.RECALCULATE_PO)
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.grid >>> {
  .ag-row.line-item-row {
    .ag-cell[col-id="action-clone"] {
      @include theme {
        width: 0 !important;
      }
    }
    .ag-cell[col-id="action-remove"] {
      @include theme {
        width: 0 !important;
      }
    }
  }
  .ag-row.readonly-row {
    .ag-cell[col-id="unitPrice"] {
      display: none;
    }
    .ag-cell[col-id="total"] {
      display: none;
    }
    .ag-cell[col-id="action-edit"] {
      @include theme {
        width: 0 !important;
      }
    }
    .ag-cell[col-id="action-clone"] {
      @include theme {
        width: 0 !important;
      }
    }
    .ag-cell[col-id="action-remove"] {
      @include theme {
        width: 0 !important;
      }
    }
  }
  .ag-row.hide-units {
    .ag-cell[col-id="units"] {
      display: none;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/_modules/I2P/LineItemsSection.vue